<div class="notifications">
  <button class="notifications__button" (click)="toggle()" type="button">
    <i class="far fa-bell"></i>
    <span
      class="notifications__badge"
      [class.notifications__badge--large]="totalBadgeCount > 99"
      *ngIf="totalBadgeCount > 0"
    >
      {{ totalBadgeCount > 99 ? '99+' : totalBadgeCount }}
    </span>
    <span class="notifications__arrow" *ngIf="isOpen"></span>
  </button>

  <div class="notifications__dropdown" *ngIf="isOpen" (click)="$event.stopPropagation()">
    <div class="notifications__sections">
      <button
        class="notifications__section-btn"
        [class.notifications__section-btn--active]="activeSection === tabs.Tasks"
        (click)="switchSection(tabs.Tasks)"
        type="button"
      >
        Tarefas
        <span
          class="notifications__filter-count notifications__filter-count--executing"
          *ngIf="tasks.length > 0"
        >{{ tasks.length }}</span>
      </button>
    </div>

    <sgt-task-list
      *ngIf="activeSection === tabs.Tasks"
      [tasks]="tasks"
      (clearAllClicked)="onClearAllTasks()"
      (errorClicked)="onShowTaskError($event)"
    ></sgt-task-list>
  </div>
</div>
